export enum userDataEvents {
    SEND_USER_DATA = 'userData/sendUserData',
}

const sendUserData = function (options = {}) {
    const event = new CustomEvent(userDataEvents.SEND_USER_DATA, {
        detail: {
            ...options,
        },
    });
    window.dispatchEvent(event);
};

export default {
    sendUserData,
};
